import { useNavigate } from 'react-router-dom'
import { CheckCircle2, Phone, RotateCcw } from 'lucide-react'
import { useBuildStore } from '@/store/build-store'
import { useConfigStore } from '@/store/config-store'
import { Header } from '@/components/layout/Header'
import { Button } from '@/components/ui/Button'
import { formatCurrency } from '@/lib/pricing'

export default function ThankYou() {
  const navigate = useNavigate()
  const { submittedTotal, submittedLeadId, selectedModelId, resetBuild } = useBuildStore()
  const { config } = useConfigStore()

  const model = config?.models.find((m) => m.id === selectedModelId)
  const thankYou = config?.settings['thank_you_message'] ?? 'Your build has been sent to L&M Custom Builders.'
  const phone = config?.settings['phone']

  const handleNewBuild = () => {
    resetBuild()
    navigate('/')
  }

  return (
    <div className="min-h-screen bg-dark-950 flex flex-col">
      <Header variant="plain" />
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-lg w-full text-center">
          <div className="h-16 w-16 bg-emerald-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="h-8 w-8 text-emerald-400" />
          </div>

          <h1 className="text-3xl font-bold text-white mb-3">Build Submitted!</h1>
          <p className="text-slate-400 text-lg leading-relaxed mb-8">{thankYou}</p>

          {model && submittedTotal && (
            <div className="bg-dark-800 border border-dark-600 rounded-xl p-6 mb-8 text-left">
              <div className="flex items-baseline justify-between mb-3">
                <span className="text-white font-semibold">{model.name}</span>
                <span className="text-brand-400 font-bold text-lg">{formatCurrency(submittedTotal)}</span>
              </div>
              <div className="text-slate-500 text-xs">
                Build reference #{submittedLeadId} · Check your email for a copy of your summary.
              </div>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button variant="secondary" onClick={handleNewBuild}>
              <RotateCcw className="h-4 w-4" /> Start Another Build
            </Button>
            {phone && (
              <Button onClick={() => window.open(`tel:${phone.replace(/\D/g, '')}`)}>
                <Phone className="h-4 w-4" /> Call L&M
              </Button>
            )}
          </div>
        </div>
      </main>
    </div>
  )
}
